import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { updateTransition } from '../store/globalReducer';

import '../assets/scss/components/pageTransitionOverlay.scss';

import cloud_1_1 from '../assets/img/common/transition_cloud_1_1.svg';
import cloud_1_2 from '../assets/img/common/transition_cloud_1_2.svg';
import cloud_1_3 from '../assets/img/common/transition_cloud_1_3.svg';
import cloud_2_1 from '../assets/img/common/transition_cloud_2_1.svg';
import cloud_2_2 from '../assets/img/common/transition_cloud_2_2.svg';

export default function PageTransitionOverlay() {
  const dispatch = useDispatch();

  const isFirstLoad = useSelector(state => state.global.isFirstLoad);
  const isTransition = useSelector(state => state.global.isTransition);
  const [isVisible, setIsVisible] = useState(false);

  const leftCloudVars = {
    initial: { x: '-100%', opacity: 0 },
    animate: { x: '0%', opacity: 1, transition: { duration: 0.65, ease: 'easeOut' } },
    exit: { x: '100%', opacity: 0, transition: { duration: 0.65, ease: 'easeOut' } }
  };

  const rightCloudVars = {
    initial: { x: '100%', opacity: 0 },
    animate: { x: '0%', opacity: 1, transition: { duration: 0.65, ease: 'easeOut' } },
    exit: { x: '-100%', opacity: 0, transition: { duration: 0.65, ease: 'easeOut' } }
  }

  useEffect(() => {
    if (isFirstLoad || !isTransition) return;
    setIsVisible(true);

    setTimeout(() => {
      setIsVisible(false);
      dispatch(updateTransition(false));
    }, 1000);
  }, [isTransition]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.2 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          className="transition-overlay">
            <div className="cloud">
              <motion.div variants={leftCloudVars} initial="initial" animate="animate" exit="exit" className="cloud__image cloud__image--first"><img src={cloud_1_1} alt="" /></motion.div>
              <motion.div variants={leftCloudVars} initial="initial" animate="animate" exit="exit" className="cloud__image cloud__image--second"><img src={cloud_1_2} alt="" /></motion.div>
              <motion.div variants={leftCloudVars} initial="initial" animate="animate" exit="exit" className="cloud__image cloud__image--third"><img src={cloud_1_3} alt="" /></motion.div>
              <motion.div variants={rightCloudVars} initial="initial" animate="animate" exit="exit" className="cloud__image cloud__image--fourth"><img src={cloud_2_1} alt="" /></motion.div>
              <motion.div variants={rightCloudVars} initial="initial" animate="animate" exit="exit" className="cloud__image cloud__image--fifth"><img src={cloud_2_2} alt="" /></motion.div>
            </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}


